/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import moment from 'moment';
import { SCREEN_REFRESH_INTERVAL_TIME_MS } from '../constants';

const useAjaxCallbackWithIntervals = (
  isAjaxCallOngoing,
  isDataBeingEdited,
  ajaxCallback,
  ...callBackParams
) => {
  const [lastRefreshedDate, setLastRefreshedDate] = useState(null);

  // effect to run the cb for the first time
  useEffect(() => {
    ajaxCallback(...callBackParams).then(() => setLastRefreshedDate(moment()));
  }, [...callBackParams]);

  // effect to run the cb again in intervals
  useEffect(() => {
    const intervalID = setInterval(() => {
      if (!isAjaxCallOngoing && !isDataBeingEdited)
        ajaxCallback(...callBackParams).then(() =>
          setLastRefreshedDate(moment()),
        );
    }, SCREEN_REFRESH_INTERVAL_TIME_MS);
    return () => {
      clearInterval(intervalID);
    };
  }, [...callBackParams, isDataBeingEdited, isAjaxCallOngoing]);

  return lastRefreshedDate;
};

export default useAjaxCallbackWithIntervals;
